import api from "@/api";

/**
 * Coloca um e-mail num funil do Workflow (POST /api/workflow/entrada).
 *
 * O backend responde "ok" igual para e-mail novo, repetido, de assinante ou
 * bloqueado — de proposito, para o formulario nao revelar quem e' cliente.
 * Entao aqui so' existem dois desfechos: deu certo, ou o e-mail e' invalido /
 * algo falhou.
 *
 * `semRedirect404`: o interceptor do cliente manda para a home em qualquer
 * 404, e um gatilho errado na pagina responde 404 — a pessoa sumiria da
 * pagina sem entender por que.
 */
export function useWorkflowEntry() {
  async function submit(payload: {
    gatilho: string;
    email: string;
    locale: string;
    website?: string;
  }) {
    try {
      const { data } = await api.post(
        "workflow/entrada",
        {
          gatilho: payload.gatilho,
          email: payload.email,
          locale: payload.locale,
          website: payload.website ?? "",
        },
        { semRedirect404: true }
      );

      return { ok: Boolean(data?.ok), message: data?.message ?? "" };
    } catch (err: any) {
      return {
        ok: false,
        message: err?.response?.data?.message ?? "",
        invalid: err?.response?.status === 422,
      };
    }
  }

  return { submit };
}
